import React, { useCallback } from "react";
import { useNavigate, useLocation } from "react-router";

import useQueryParams from "src/hooks/useQueryParams";
import InboundChargesSummaryModalWrapper from "./InboundChargesSummaryModalWrapper";
import OutboundChargesSummaryModalWrapper from "./OutboundChargesSummaryModalWrapper";
import InternalWorkOrderChargesSummaryModalWrapper from "./InternalWorkOrderChargesSummaryModalWrapper";
import AssetChargesSummaryModalWrapper from "./AssetChargesSummaryModalWrapper";

export default function ChargesSummaryModals() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = useQueryParams();

  const inboundChargesSummaryId = queryParams.get("inboundChargesSummaryId");
  const outboundChargesSummaryId = queryParams.get("outboundChargesSummaryId");
  const iwoChargesSummaryId = queryParams.get("iwoChargesSummaryId");
  const assetChargesSummaryId = queryParams.get("assetChargesSummaryId");

  const closeByRemovingParam = useCallback(
    (paramName) => {
      const params = new URLSearchParams(location.search);
      params.delete(paramName);
      params.delete("openChargesInfoModal");
      params.delete("openBillingQuantitiesModal");
      navigate({ pathname: location.pathname, search: params.toString() });
    },
    [navigate, location.pathname, location.search]
  );

  return (
    <>
      {inboundChargesSummaryId && (
        <InboundChargesSummaryModalWrapper
          inboundChargesSummaryId={inboundChargesSummaryId}
          onClose={() => closeByRemovingParam("inboundChargesSummaryId")}
        />
      )}
      {outboundChargesSummaryId && (
        <OutboundChargesSummaryModalWrapper
          outboundChargesSummaryId={outboundChargesSummaryId}
          onClose={() => closeByRemovingParam("outboundChargesSummaryId")}
        />
      )}
      {iwoChargesSummaryId && (
        <InternalWorkOrderChargesSummaryModalWrapper
          iwoChargesSummaryId={iwoChargesSummaryId}
          onClose={() => closeByRemovingParam("iwoChargesSummaryId")}
        />
      )}

      {assetChargesSummaryId && <AssetChargesSummaryModalWrapper />}
    </>
  );
}
